import { EVENTS } from "@/constants/socket";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useSocket } from '@/features/chat/providers/SocketProvider';
import { useCheckUnread } from "@/api/services/main/information";

export const useUnreadNotification = () => {
  const queryClient = useQueryClient();
  const { data: checkResult } = useCheckUnread({ types: ["case_comment"] });

  const { socket } = useSocket();

  const handleNewNotification = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INFORMATION.CHECK_UNREAD] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INFORMATION.FETCH_LIST] });
  }, [queryClient]);

  // Announcements are not shown in the bell, so the red dot (CHECK_UNREAD) is not refreshed
  const handleNewAnnouncement = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INFORMATION.FETCH_LIST] });
  }, [queryClient]);

  useEffect(() => {
    if (!socket) return;

    socket.on(EVENTS.INFORMATION.NEW_INFORMATION, handleNewNotification);
    socket.on(EVENTS.INFORMATION.NEW_ANNOUNCEMENT, handleNewAnnouncement);

    return () => {
      socket.off(EVENTS.INFORMATION.NEW_INFORMATION, handleNewNotification);
      socket.off(EVENTS.INFORMATION.NEW_ANNOUNCEMENT, handleNewAnnouncement);
    };
  }, [socket, handleNewNotification, handleNewAnnouncement]);

  return checkResult;
};
